//App.js is a root component that serves as the entry points for other components.

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; //for routing
import Home from './pages/Home';
import About from './pages/About';
import Navbar from './components/Navbar';
import ProductsPage from './pages/ProductsPage';
import Cart from './pages/Cart';
import ProductPage from './pages/ProductPage';
import { CartContext } from './CartContex';
import { useEffect, useState } from 'react';

//first letter should be capital as this is a component
const App = () => {
    const [cart, setCart] = useState({});
    //fetch from local storage
    useEffect(()=>{
        const cart = window.localStorage.getItem('cart');
        setCart(JSON.parse(cart));
    },[] )

    useEffect(() => {
        window.localStorage.setItem('cart',JSON.stringify(cart));
    },[cart]);

    //jsx must have one parent element we can use react fragments <> </> or <div>
    return (
        <>
            <Router>
                <CartContext.Provider value={{ cart, setCart }}>
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/products" exact element={<ProductsPage />} />
                        <Route path="/products/:id" element={<ProductPage />} />
                        <Route path="/cart" element={<Cart />} />
                    </Routes>
                </CartContext.Provider >
            </Router>
        </>
    );
};

export default App;
